import { createRouter, createWebHistory } from "vue-router";
import App from "@/App.vue";
import store from "@/store/index.js";

const routes = [
  {
    path: "/",
    name: "app",
    component: App,
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/components/Main.vue"),
        /*component: () => import('@/components/Dashboard.vue')*/
      },
      {
        path: "/signup",
        name: "signup",
        component: () => import("@/components/accounts/SignUp.vue"),
      },
      {
        path: "/login",
        name: "login",
        component: () => import("@/components/Login.vue"),
      },
      {
        path: "/findLoginId",
        name: "findLoginId",
        component: () => import("@/components/FindLoginId.vue"),
      },
      {
        path: "/findLoginPassword",
        name: "findLoginPassword",
        component: () => import("@/components/FindLoginPassword.vue"),
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/components/profile/Profile.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/applyCounselling",
        name: "applyCounselling",
        component: () => import("@/components/medical/counselling/ApplyCounselling.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/counsellingList",
        name: "counsellingList",
        component: () => import("@/components/medical/counselling/CounsellingList.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/counsellingDetail",
        name: "counsellingDetail",
        component: () => import("@/components/medical/counselling/CounsellingDetail.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/applySecondOpinion",
        name: "applySecondOpinion",
        component: () => import("@/components/medical/secondOpinion/ApplySecondOpinion.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/secondOpinionList",
        name: "secondOpinionList",
        component: () => import("@/components/medical/secondOpinion/SecondOpinionList.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/secondOpinionDetail",
        name: "secondOpinionDetail",
        component: () => import("@/components/medical/secondOpinion/SecondOpinionDetail.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/howToTreatment",
        name: "howToTreatment",
        component: () => import("@/components/guide/HowToTreatment.vue"),
      },
      {
        path: "/treatmentList",
        name: "treatmentList",
        component: () => import("@/components/medical/treatment/TreatmentList.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/treatmentDetail",
        name: "treatmentDetail",
        component: () => import("@/components/medical/treatment/TreatmentDetail.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/medicalFileList",
        name: "medicalFileList",
        component: () => import("@/components/medical/MedicalFileList.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/paymentList",
        name: "paymentList",
        component: () => import("@/components/payment/PaymentList.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/payment/eximbay/result",
        redirect: "/paymentList",
      },
      {
        path: "/medicalInspectionRecordList",
        name: "medicalInspectionRecordList",
        component: () => import("@/components/medical/MedicalInspectionRecordList.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/customerInquiryList",
        name: "customerInquiryList",
        component: () => import("@/components/customerInquiry/CustomerInquiryList.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/customerInquiryForm",
        name: "customerInquiryForm",
        component: () => import("@/components/customerInquiry/CustomerInquiryForm.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/customerInquiryDetail",
        name: "customerInquiryDetail",
        component: () => import("@/components/customerInquiry/CustomerInquiryDetail.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/counsellingList",
        name: "counsellingList",
        component: () => import("@/components/medical/counselling/CounsellingList.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/healthMagazineHealth",
        name: "healthMagazineHealth",
        component: () => import("@/components/HealthMagazineHealth.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/healthMagazineHospital",
        name: "healthMagazineHospital",
        component: () => import("@/components/HealthMagazineHospital.vue"),
        meta: { requiresAuth: false },
      }, 
      {
        path: "/magazineDetail",
        name: "magazineDetail",
        component: () => import("@/components/MagazineDetail.vue"),
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    path: "/CHAGroup",
    name: "CHAGroup",
    component: App,
    children : [
      {
        path: "introduce",
        name: "chagroupIntroduce",
      component: () => import("@/components/intro/group/GroupIntro.vue"),
      },
      {
        path: "history",
        name: "chagroupHistory",
        component: () => import("@/components/intro/group/GroupHistory.vue"),
      },
      {
        path: "rewards",
        name: "chagroupReward",
        component: () => import("@/components/intro/group/GroupRewards.vue"),
      },
      {
        path: "globalNetwork",
        name: "chagroupGlobalNetwork",
        component: () => import("@/components/intro/group/GroupGlobalNetwork.vue"),
      },
    ]
  },
  {
    path: "/CHAHospital",
    name: "hospitalIntroduce",
    component: App,
    children : [
      {
        path: "ilsanHospital",
        name: "ilsanIntro",
        component: () => import("@/components/intro/hospital/IlsanHospital.vue"),
      },
      {
        path: "gangnamHospital",
        name: "gangnamIntro",
        component: () => import("@/components/intro/hospital/GangnamHospital.vue"),
      },
      {
        path: "bundangHospital",
        name: "bundangHospitalIntro",
        component: () => import("@/components/intro/hospital/BundangHospital.vue"),
      },
      {
        path: "gumiHospital",
        name: "gumiIntro",
        component: () => import("@/components/intro/hospital/GumiHospital.vue"),
      },
      {
        path: "womenMedicine",
        name: "womenIntro",
        component: () => import("@/components/intro/hospital/WomenMedicine.vue"),
      },
      {
        path: "healthCenter",
        name: "healthIntro",
        component: () => import("@/components/intro/hospital/HealthCenter.vue"),
      },
      {
        path: "globalHospital",
        name: "globalIntro",
        component: () => import("@/components/intro/hospital/GlobalHospital.vue"),
      },
    ]
  },
  {
    path: "/CHADepartment",
    name: "CHADepartment",
    component: App,
    children : [
      {
        path: "infertility",
        name: "infertility",
        component: () => import("@/components/intro/dept/Infertility.vue"),
      },
      {
        path: "37bank",
        name: "37bank",
        component: () => import("@/components/intro/dept/37bank.vue"),
      },
      {
        path: "femaleCancer",
        name: "femaleCancer",
        component: () => import("@/components/intro/dept/FemaleCancer.vue"),
      },
      {
        path: "roboticSurgery",
        name: "roboticSurgery",
        component: () => import("@/components/intro/dept/RoboticSurgery.vue"),
      },
    ]
  },
  {
    path: "/CHADoctor",
    name: "CHADoctor",
    component: App,
    children : [
      // {
      //   path: "ilsanHospital",
      //   name: "ilsanHospital",
      //   component: () => import("@/components/intro/doctor/IlsanHospital.vue"),
      // },
      // {
      //   path: "gangnamHospital",
      //   name: "gangnamHospital",
      //   component: () => import("@/components/intro/doctor/GangnamHospital.vue"),
      // },
      {
        path: "FieldInfertility",
        name: "FieldInfertility",
        component: () => import("@/components/intro/doctor/FieldInfertility.vue"),
      },
      {
        path: "FieldObstetrics",
        name: "FieldObstetrics",
        component: () => import("@/components/intro/doctor/FieldObstetrics.vue"),
      },
      {
        path: "FieldBreastsurgery",
        name: "FieldBreastsurgery",
        component: () => import("@/components/intro/doctor/FieldBreastsurgery.vue"),
      },
      {
        path: "FieldThyroid",
        name: "FieldThyroid",
        component: () => import("@/components/intro/doctor/FieldThyroid.vue"),
      },
      {
        path: "FieldCancer",
        name: "FieldCancer",
        component: () => import("@/components/intro/doctor/FieldCancer.vue"),
      },
      {
        path: "FieldGynecology",
        name: "FieldGynecology",
        component: () => import("@/components/intro/doctor/FieldGynecology.vue"),
      },
      {
        path: "gangnamHospital",
        name: "gangnamHospital",
        component: () => import("@/components/intro/doctor/GangnamHospital.vue"),
      },
      {
        path: "FieldGastroenterology",
        name: "FieldGastroenterology",
        component: () => import("@/components/intro/doctor/FieldGastroenterology.vue"),
      },
      {
        path: "FieldEndocrinology",
        name: "FieldEndocrinology",
        component: () => import("@/components/intro/doctor/FieldEndocrinology.vue"),
      },
      {
        path: "FieldFamilymedicine",
        name: "FieldFamilymedicine",
        component: () => import("@/components/intro/doctor/FieldFamilymedicine.vue"),
      }

    ]
  },
  {
    path: "/paymentdemo",
    name: "paymentdemo",
    component: () => import("@/components/payment/PaymentDemo.vue"),
  },
  {
    path: "/paymentdemoreturn",
    name: "paymentdemoreturn",
    component: () => import("@/components/payment/PaymentDemoReturn.vue"),
  },
  {
    path: "/zoomdemo",
    name: "zoomdemo",
    component: () => import("@/components/zoom/ZoomDemo.vue"),
  },

  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/components/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const changeLocale = (lang) => {
  store.dispatch("locale/saveLocale", {locale: lang});
}

router.beforeResolve((to, from, next) => {
  if(to.query.lang != undefined) { 
    changeLocale(to.query.lang)
  }
  
  const isLogined = store.getters["auth/isLogined"];
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLogined) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    if (to.name === "login") {
      if (isLogined) {
        next({ path: "/" });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});

export default router;
